import { AUTO_DISMISS_SECONDS, NOTIFICATION_MESSAGES } from '../shared/utils'
import { clearSongList } from '../action_creators/new_songs'
import {
  CLICK_ON_PREFERENCES,
  RECEIVE_PREFERENCES,
  REQUEST_PREFERENCES,
} from '../action_constants'
import { error, success } from 'react-notification-system-redux'
import { fetchWithHeaders, parseResponse } from '../shared/utils'
import { intl } from '../shared/IntlGlobalProvider'

const successNotification = intl => {
  return {
    title: intl.formatMessage(NOTIFICATION_MESSAGES.yourPreferencesTitle),
    message: intl.formatMessage(
      NOTIFICATION_MESSAGES.yourPreferencesActionSuccess
    ),
    position: 'tr',
    autoDismiss: AUTO_DISMISS_SECONDS,
  }
}

const errorNotification = intl => {
  return {
    title: intl.formatMessage(NOTIFICATION_MESSAGES.yourPreferencesTitle),
    message: intl.formatMessage(
      NOTIFICATION_MESSAGES.yourPreferencesActionError
    ),
    position: 'tr',
    autoDismiss: AUTO_DISMISS_SECONDS,
  }
}

export const requestPreferences = () => {
  return {
    type: REQUEST_PREFERENCES,
  }
}

export const clickOnPreferences = (
  preferencesClicked,
  genrePreferencesClicked
) => {
  return {
    type: CLICK_ON_PREFERENCES,
    preferencesClicked,
    genrePreferencesClicked,
  }
}

export const receivePreferences = (preferences, genrePreferences) => {
  return {
    type: RECEIVE_PREFERENCES,
    preferences,
    genrePreferences,
  }
}

export const getPreferences = () => dispatch => {
  dispatch(requestPreferences())
  return Promise.all([
    fetchWithHeaders('/users/preferences', { method: 'GET' })
      .then(parseResponse)
      .then(res => res.data),
    fetchWithHeaders('/users/preferences/genres', { method: 'GET' })
      .then(parseResponse)
      .then(res => res.data),
  ])
    .then(([preferences, genrePreferences]) => {
      const err = preferences.error || genrePreferences.error
      if (err) {
        return dispatch(
          error({
            ...errorNotification(intl),
            message: err.userDescription || err.message,
          })
        )
      }
      dispatch(receivePreferences(preferences, genrePreferences))
    })
    .catch(err =>
      dispatch(
        error({
          ...errorNotification(intl),
          message: err.message,
        })
      )
    )
}

export const selectPreference = (
  preferences,
  genrePreferences,
  preferencesClicked,
  genrePreferencesClicked
) => dispatch => {
  dispatch(clickOnPreferences(preferencesClicked, genrePreferencesClicked))
  return Promise.all(
    [
      fetchWithHeaders('/users/preferences', {
        method: 'PUT',
        body: JSON.stringify(preferences),
      })
        .then(parseResponse)
        .then(res => res.data),
    ],
    fetchWithHeaders('/users/preferences/genres', {
      method: 'PUT',
      body: JSON.stringify(genrePreferences),
    })
      .then(parseResponse)
      .then(res => res.data)
  )
    .then(([preferences, genrePreferences]) =>
      dispatch(receivePreferences(preferences, genrePreferences))
    )
    .then(() => dispatch(clearSongList())) // Clear new releases because preference dependent
    .then(() => dispatch(getPreferences()))
    .then(() => dispatch(success(successNotification(intl))))
    .catch(err =>
      dispatch(
        error({
          ...errorNotification(intl),
          message: err.message,
        })
      )
    )
}
